import HeaderCurrencySwitcher from "@/components/Header/HeaderCurrencySwitcher";
import HeaderLanguageSwitcher from "@/components/Header/HeaderLanguageSwitcher";
import { MegaMenuHeaderItemList } from "@/components/mega-menu/MegaMenuHeaderItemList";
import {
  MegaMenuProvider,
  useMegaMenuState,
} from "@/components/mega-menu/MegaMenuProvider";
import { MegaMenuViewport } from "@/components/mega-menu/MegaMenuViewport";
import { useMegaMenuData } from "@/components/mega-menu/hooks/useMegaMenuData";
import { DeliveryLocation } from "@/features/delivery-location/components/DeliveryLocation";
import { NavigationMenu } from "@radix-ui/react-navigation-menu";

/**
 * Mega menu "main" entries.
 */
const MegaMenuContent = () => {
  const { data } = useMegaMenuData();
  const { activeMenu } = useMegaMenuState();

  return (
    <NavigationMenu
      value={activeMenu}
      className="flex items-end justify-between"
    >
      <MegaMenuHeaderItemList items={data?.items} />
      <div className="flex shrink-0 items-end gap-3">
        <DeliveryLocation className="max-w-[18rem] pb-4" />
        <span className="mb-[1.375rem] h-4 w-px shrink-0 bg-grey-300" />
        <HeaderLanguageSwitcher />
        <HeaderCurrencySwitcher />
      </div>
      <MegaMenuViewport />
    </NavigationMenu>
  );
};

export const MegaMenu = () => {
  return (
    <MegaMenuProvider>
      <MegaMenuContent />
    </MegaMenuProvider>
  );
};
